import { MealRecipe, MealType } from '@akin-home/amplify';
import { getId, Meal } from '../../models';
import { Recipe } from '../../recipes/types';
import { addHours } from '../../utils/dateTime';

/** Gets the start time for a given meal type */
export const getMealTypeStartTime = (mealType: MealType, date?: Date): Date => {
  const start = date || new Date();
  start.setMinutes(0);

  switch (mealType) {
    case 'Breakfast': {
      start.setHours(7);
      break;
    }
    case 'Lunch': {
      start.setHours(12);
      break;
    }
    case 'Dinner': {
      start.setHours(19);
      break;
    }
    case 'Snack': {
      start.setHours(15);
      break;
    }
  }

  return start;
};

/** Gets default start and end datetimes for a mealType */
export const getMealTypeTimes = (
  mealType: MealType,
  date?: Date
): { start: Date; end: Date } => {
  const start = getMealTypeStartTime(mealType, date);

  return {
    start,
    end: addHours(start, 1),
  };
};

/**
 * Changes the meal type
 */
export const changeMealType = (meal: Meal, mealType: MealType): Meal => {
  const times = getMealTypeTimes(mealType);

  return { ...meal, ...times, mealType };
};

/** Resets the datetime fields for the meal based on it's type */
export const resetMealTypeDateTimes = (meal: Meal): Meal =>
  changeMealType(meal, meal.mealType);

export const getRecipeM2mDiff = (
  recipes: Recipe[],
  recipeM2m: MealRecipe[]
): { add: string[]; delete: string[] } => {
  const m2mRecipeIds = recipeM2m.map((m2m) => m2m.recipeID) as string[];
  const recipeIds = recipes.map(getId);

  return {
    add: recipeIds.filter((recipeID) => !m2mRecipeIds.includes(recipeID)),
    delete: recipeM2m
      .filter((m2m) => !recipeIds.includes(m2m.recipeID as string))
      .map(getId),
  };
};
